'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTether = require('react-tether');

var _reactTether2 = _interopRequireDefault(_reactTether);

var _ToolTip = require('./ToolTip');

var _ToolTip2 = _interopRequireDefault(_ToolTip);

var _Price = require('./Price');

var _Price2 = _interopRequireDefault(_Price);

var _trvFedUtil = require('../trv-fed-util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_PLAN_NUMBER = 3; // Rooms

var TaxesFeeds = function TaxesFeeds(props) {
  var taxesAndFeedsLead = props.taxesAndFeedsLead;

  return _react2.default.createElement(
    'div',
    null,
    ' ',
    taxesAndFeedsLead,
    ' '
  );
};

TaxesFeeds.propTypes = {
  taxesAndFeedsLead: _react.PropTypes.string.isRequired
};

var Plan = function (_Component) {
  (0, _inherits3.default)(Plan, _Component);

  function Plan(props) {
    (0, _classCallCheck3.default)(this, Plan);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Plan.__proto__ || (0, _getPrototypeOf2.default)(Plan)).call(this, props));

    _this.state = { isMoreDetailOpen: false };
    _this.handleClickOutside = _this.handleClickOutside.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Plan, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // XXX: Actually a bad pollusion to global document
      // Should be moved to a global container to manage them in one place.
      document.addEventListener('click', this.handleClickOutside);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClickOutside);
    }
  }, {
    key: 'toggleDetail',
    value: function toggleDetail() {
      this.setState({ isMoreDetailOpen: !this.state.isMoreDetailOpen });
    }
  }, {
    key: 'handleClickOutside',
    value: function handleClickOutside(e) {
      if (this.tipSwitcher && e.target === this.tipSwitcher) {
        return; // this part is handled by toggleDetail.
      }
      if (!this.state.isMoreDetailOpen) {
        return;
      }
      this.setState({ isMoreDetailOpen: false });
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      this.props.handleClick(this.props.plan.media);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          i18n = _props.i18n,
          room = _props.room,
          plan = _props.plan,
          isDateless = _props.isDateless,
          isMobile = _props.isMobile,
          children = _props.children,
          className = _props.className,
          onPlanClick = _props.onPlanClick,
          currency = _props.currency;
      var isMoreDetailOpen = this.state.isMoreDetailOpen;

      return _react2.default.createElement(
        'tr',
        { className: className },
        children,
        _react2.default.createElement(Rate, { i18n: i18n, plan: plan, isMobile: isMobile, handleClick: this.handleClick }),
        _react2.default.createElement(
          'td',
          { rowSpan: 1, className: 'room-price' },
          _react2.default.createElement(_Price2.default, { i18n: i18n, item: (0, _extends3.default)({}, plan, { lead: plan.priceLead }), currency: currency }),
          plan.priceLead ? _react2.default.createElement(
            'div',
            { className: 'about-price' },
            plan.priceLead
          ) : null,
          plan.point ? _react2.default.createElement(
            'div',
            { className: 'point-info' },
            i18n.hotelInformation.earnPoints.split(/({.*?})/).map(function (item, index) {
              // eslint-disable-next-line react/no-array-index-key
              return item === '{rate}' ? _react2.default.createElement(
                'span',
                { key: index, className: Number(plan.pointRatio) > 1 ? 'point10x' : '' },
                plan.pointRatio + 'x'
              ) : item.trim() || undefined;
            })
          ) : null,
          plan.point ? _react2.default.createElement(
            'div',
            { className: 'get-point' },
            i18n.hotelInformation.numberOfPoints.split(/({.*?})/).map(function (item, index) {
              switch (item) {
                case '{number}':
                  // eslint-disable-next-line react/no-array-index-key
                  return _react2.default.createElement(
                    'span',
                    { key: index, className: 'get-point-detail' },
                    new Intl.NumberFormat(i18n.lang.replace('_', '-')).format(Number(plan.point))
                  );
                case '{point}':
                  // eslint-disable-next-line react/no-array-index-key
                  return _react2.default.createElement(
                    'span',
                    { key: index, className: 'point-title' },
                    Number(plan.point.replace(/[^0-9.]+/g, '')) > 1 ? i18n.hotelInformation.Points : i18n.hotelInformation.Point
                  );
                default:
                  return item.trim() || undefined;
              }
            })
          ) : null,
          !isDateless ? _react2.default.createElement(
            'div',
            { className: 'price-tax-feeds' },
            _react2.default.createElement(
              _reactTether2.default,
              {
                attachment: 'top center' /* "same as PC" in the UX spec */
              },
              _react2.default.createElement(
                'span',
                {
                  'data-target': '#tooltip',
                  title: true,
                  'data-role': 'tooltip-target'
                },
                _react2.default.createElement(
                  'a',
                  {
                    href: true,
                    ref: function ref(tipSwitcher) {
                      _this2.tipSwitcher = tipSwitcher;
                    },
                    onClick: function onClick(e) {
                      e.preventDefault();
                      _this2.toggleDetail();
                    }
                  },
                  i18n.hotelInformation.taxesAndFeesShowMore
                )
              ),
              isMoreDetailOpen && _react2.default.createElement(
                _ToolTip2.default,
                null,
                _react2.default.createElement(TaxesFeeds, { taxesAndFeedsLead: plan.taxesAndFeedsLead })
              )
            )
          ) : null
        ),
        _react2.default.createElement(
          'td',
          { rowSpan: 1, className: 'room-buttons' },
          _react2.default.createElement(
            'div',
            { className: 'book-button-wrapper' },
            _react2.default.createElement(
              'button',
              {
                type: 'button',
                className: 'book-button',
                onClick: function onClick() {
                  // XXX: the ID property of a room is 'room'
                  onPlanClick(room.room, plan.id);
                }
              },
              _react2.default.createElement(
                'span',
                { className: 'btn-label' },
                _react2.default.createElement(
                  'span',
                  { 'aria-hidden': 'true' },
                  isDateless ? i18n.hotelInformation.checkRates : i18n.hotelInformation.bookNow
                ),
                _react2.default.createElement(
                  'span',
                  { className: 'for-reader' },
                  isDateless ? i18n.hotelInformation.checkPlan.replace(/{plan}/g, plan.name) : i18n.hotelInformation.bookPlan.replace(/{plan}/g, plan.name)
                )
              )
            )
          ),
          !isDateless && plan.roomLeft ? _react2.default.createElement(
            'div',
            { className: 'room-left' },

            /* XXX: a cumbersome way to deal with i18n plurals */
            i18n.hotelInformation.roomLeft.replace(/{number}/g, plan.roomLeft).replace(/{room}/g, plan.roomLeft > 1 ? i18n.hotelSearch.rooms : i18n.hotelSearch.room)
          ) : null
        )
      );
    }
  }]);
  return Plan;
}(_react.Component);

Plan.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  room: _react.PropTypes.object.isRequired,
  plan: _react.PropTypes.object.isRequired,
  isDateless: _react.PropTypes.bool,
  isMobile: _react.PropTypes.bool,
  children: _react.PropTypes.element,
  className: _react.PropTypes.string,
  onPlanClick: _react.PropTypes.func.isRequired,
  currency: _react.PropTypes.object.isRequired,
  handleClick: _react.PropTypes.func.isRequired
};

Plan.defaultProps = {
  isDateless: true,
  isMobile: false,
  className: '',
  children: _react2.default.createElement('div', null)
};

var Type = function (_Component2) {
  (0, _inherits3.default)(Type, _Component2);

  function Type(props) {
    (0, _classCallCheck3.default)(this, Type);

    var _this3 = (0, _possibleConstructorReturn3.default)(this, (Type.__proto__ || (0, _getPrototypeOf2.default)(Type)).call(this, props));

    _this3.state = {
      isOpen: false
    };

    _this3.handleClick = _this3.handleClick.bind(_this3);
    return _this3;
  }

  (0, _createClass3.default)(Type, [{
    key: 'handleClick',
    value: function handleClick(e) {
      e.preventDefault();
      this.props.handleClick(this.props.item.media);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          i18n = _props2.i18n,
          item = _props2.item,
          rowSpan = _props2.rowSpan;


      return _react2.default.createElement(
        'td',
        { rowSpan: rowSpan, className: 'room-type' },
        _react2.default.createElement(
          'div',
          { className: 'room-name' },
          _react2.default.createElement(
            'h3',
            null,
            item.name
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'room-thumbnail' },
          _react2.default.createElement(
            'a',
            { href: true, onClick: this.handleClick },
            item.media && item.media.length ? _react2.default.createElement('img', {
              src: (0, _trvFedUtil.concateQueryParamsToImageUrl)(item.media[0].thumbnailUrl, 400),
              alt: ''
            }) : null
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'room-additional-info' },
          _react2.default.createElement(
            'div',
            { className: 'room-free-text' },
            item.facilityLead
          ),
          _react2.default.createElement(
            'div',
            { className: 'room-occupancy-max' },
            item.personLimit && i18n.hotelInformation.occupancyMax.replace(/{number}/g, item.personLimit)
          ),
          _react2.default.createElement(
            'div',
            { className: 'room-smoking-info' },
            item.smokingLead
          )
        )
      );
    }
  }]);
  return Type;
}(_react.Component);

Type.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  item: _react.PropTypes.object.isRequired,
  rowSpan: _react.PropTypes.number.isRequired,
  handleClick: _react.PropTypes.func.isRequired
};

Type.defaultProps = {
  item: {
    facilityLead: '',
    smokingLead: ''
  }
};

var Rate = function (_Component3) {
  (0, _inherits3.default)(Rate, _Component3);

  function Rate(props) {
    (0, _classCallCheck3.default)(this, Rate);

    var _this4 = (0, _possibleConstructorReturn3.default)(this, (Rate.__proto__ || (0, _getPrototypeOf2.default)(Rate)).call(this, props));

    _this4.state = {
      isMoreDetailOpen: false
    };

    _this4.handleClickOutside = _this4.handleClickOutside.bind(_this4);
    _this4.handleClick = _this4.handleClick.bind(_this4);
    return _this4;
  }

  (0, _createClass3.default)(Rate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.addEventListener('click', this.handleClickOutside);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClickOutside);
    }
  }, {
    key: 'handleClickOutside',
    value: function handleClickOutside(e) {
      if (this.node && !this.node.contains(e.target) && this.state.isMoreDetailOpen) {
        this.setState({ isMoreDetailOpen: false });
      }
    }
  }, {
    key: 'toggleDetail',
    value: function toggleDetail(e) {
      e.preventDefault();
      this.setState({ isMoreDetailOpen: !this.state.isMoreDetailOpen });
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e) {
      e.preventDefault();
      this.props.handleClick(this.props.plan.media);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props3 = this.props,
          i18n = _props3.i18n,
          plan = _props3.plan,
          isMobile = _props3.isMobile;
      var isMoreDetailOpen = this.state.isMoreDetailOpen;


      return _react2.default.createElement(
        'td',
        { rowSpan: 1, className: 'room-rates' },
        _react2.default.createElement(
          'div',
          { className: 'room-plan-name' },
          _react2.default.createElement(
            'h3',
            null,
            plan.name
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'plan-thumbnail' },
          _react2.default.createElement(
            'a',
            { href: true, onClick: this.handleClick },
            plan.media && plan.media.length ? _react2.default.createElement('img', {
              src: (0, _trvFedUtil.concateQueryParamsToImageUrl)(plan.media[0].thumbnailUrl, 200),
              alt: ''
            }) : null
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'plan-info' },
          plan.mealsLead && _react2.default.createElement(
            'div',
            { className: 'plan-meal' },
            plan.mealsLead
          ),

          // TODO: would be better to replace the margin-top with margin-bottom
          plan.paymentLead && _react2.default.createElement(
            'div',
            { className: 'plan-payment' },
            plan.paymentLead
          ),
          plan.detail && _react2.default.createElement(
            'div',
            { className: 'plan-details' },
            _react2.default.createElement(
              _reactTether2.default,
              {
                attachment: 'top ' + (isMobile ? 'left' : 'center')
              },
              _react2.default.createElement(
                'span',
                {
                  'data-target': '#tooltip',
                  title: true,
                  'data-role': 'tooltip-target',
                  className: 'icon-question'
                },
                _react2.default.createElement(
                  'a',
                  {
                    href: true,
                    ref: function ref(node) {
                      _this5.node = node;
                    },
                    onClick: function onClick(e) {
                      _this5.toggleDetail(e);
                    }
                  },
                  i18n.hotelInformation.more
                )
              ),
              isMoreDetailOpen && _react2.default.createElement(
                'div',
                { id: 'tooltip', className: 'tooltip' },
                _react2.default.createElement(
                  'div',
                  { className: 'panel-tooltip' },
                  _react2.default.createElement(
                    'div',
                    { className: 'media-bottom' },
                    _react2.default.createElement(
                      'div',
                      { className: 'plan-details-info' },
                      _react2.default.createElement(
                        'div',
                        { className: 'detail-paragraph' },
                        _react2.default.createElement('div', { className: 'detail-paragraph-box', dangerouslySetInnerHTML: { __html: plan.detail } })
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Rate;
}(_react.Component);

Rate.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  plan: _react.PropTypes.object.isRequired,
  isMobile: _react.PropTypes.bool,
  handleClick: _react.PropTypes.func.isRequired
};

Rate.defaultProps = {
  isMobile: false
};

var Rooms = function (_Component4) {
  (0, _inherits3.default)(Rooms, _Component4);

  function Rooms(props) {
    (0, _classCallCheck3.default)(this, Rooms);

    var _this6 = (0, _possibleConstructorReturn3.default)(this, (Rooms.__proto__ || (0, _getPrototypeOf2.default)(Rooms)).call(this, props));

    _this6.state = {};
    return _this6;
  }

  (0, _createClass3.default)(Rooms, [{
    key: 'toggle',
    value: function toggle(e, index) {
      e.preventDefault();
      // the showAll state for each room, can be access by object key like this.state[`showAll${index}`]
      // ex:
      // this.state.showAll0
      // this.state.showAll1
      var state = (0, _assign2.default)({}, this.state);
      var prop = 'showAll' + index;
      state[prop] = !this.state[prop];
      this.setState(state);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var _props4 = this.props,
          i18n = _props4.i18n,
          items = _props4.items,
          isDateless = _props4.isDateless,
          isMobile = _props4.isMobile,
          onPlanClick = _props4.onPlanClick,
          handleClick = _props4.handleClick,
          currency = _props4.currency;


      return _react2.default.createElement(
        'div',
        { className: 'full-width-box no-float hotel-rooms' },
        _react2.default.createElement(
          'div',
          { className: 'rooms-rates' },
          _react2.default.createElement(
            'table',
            { className: 'rooms-rates-table' },
            _react2.default.createElement(
              'caption',
              { className: 'for-reader' },
              i18n.hotelInformation.rooms
            ),
            _react2.default.createElement(
              'thead',
              null,
              _react2.default.createElement(
                'tr',
                { id: 'rooms-header' },
                _react2.default.createElement(
                  'th',
                  { scope: 'col', id: 'room-type-header' },
                  i18n.hotelInformation.roomType
                ),
                _react2.default.createElement(
                  'th',
                  { scope: 'col', id: 'rates-header' },
                  i18n.hotelInformation.rates
                ),
                _react2.default.createElement(
                  'th',
                  { scope: 'col', id: 'price-header' },
                  i18n.hotelInformation.price
                ),
                _react2.default.createElement(
                  'th',
                  { scope: 'col', id: 'buttons-header' },
                  _react2.default.createElement(
                    'span',
                    { className: 'for-reader' },
                    i18n.hotelInformation.check
                  )
                )
              )
            ),
            _react2.default.createElement(
              'tbody',
              { className: 'rooms-body' },
              items.reduce(function (previous, item, roomIndex) {
                var result = previous.concat(item.plans.filter(function (plan, index) {
                  return _this7.state['showAll' + roomIndex] || index < DEFAULT_PLAN_NUMBER;
                }).map(function (plan, index) {
                  return _react2.default.createElement(
                    Plan,
                    {
                      key: item.room + '-' + plan.id,
                      i18n: i18n,
                      room: item,
                      plan: plan,
                      isDateless: isDateless,
                      isMobile: isMobile,
                      onPlanClick: onPlanClick,
                      className: index > 0 ? 'rooms-multi-plan' : 'rooms-plan',
                      currency: currency,
                      handleClick: handleClick
                    },
                    index < 1 ? _react2.default.createElement(Type, {
                      i18n: i18n,
                      item: item,
                      rowSpan: item.plans.length <= DEFAULT_PLAN_NUMBER ? item.plans.length : _this7.state['showAll' + roomIndex] ? item.plans.length + 1 : DEFAULT_PLAN_NUMBER + 1,
                      handleClick: handleClick
                    }) : null
                  );
                }));

                if (item.plans.length > DEFAULT_PLAN_NUMBER) {
                  result = result.concat(
                  // eslint-disable-next-line react/no-array-index-key
                  _react2.default.createElement(
                    'tr',
                    { key: 'view-more-plan' + roomIndex, className: 'view-more-plan' },
                    _react2.default.createElement(
                      'td',
                      { colSpan: _this7.state['showAll' + roomIndex] ? item.plans.length : DEFAULT_PLAN_NUMBER },
                      _react2.default.createElement(
                        'div',
                        { className: 'more-less' },
                        _react2.default.createElement(
                          'a',
                          { href: true, className: 'toggle-icon-box toggle-' + (_this7.state['showAll' + roomIndex] ? 'opened' : 'closed'), onClick: function onClick(e) {
                              return _this7.toggle(e, roomIndex);
                            } },
                          _react2.default.createElement(
                            'span',
                            { className: 'toggle-title' },
                            _this7.state['showAll' + roomIndex] ? i18n.hotelSearch.readLess : i18n.hotelSearch.readMore
                          ),
                          _react2.default.createElement('span', { className: 'toggle' })
                        )
                      )
                    )
                  ));
                }

                return result;
              }, [])
            )
          )
        )
      );
    }
  }]);
  return Rooms;
}(_react.Component);

Rooms.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  items: _react.PropTypes.array.isRequired,
  isDateless: _react.PropTypes.bool,
  isMobile: _react.PropTypes.bool,
  onPlanClick: _react.PropTypes.func.isRequired,
  currency: _react.PropTypes.object.isRequired,
  handleClick: _react.PropTypes.func.isRequired
};

Rooms.defaultProps = {
  isDateless: true,
  isMobile: false
};

exports.default = Rooms;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Rooms.js
// module id = 1224
// module chunks = 0